import moment from "moment";
import Toast from 'light-toast';
import { getMetaDataCall, getLoginUserTokenForExternalAPICall, getUserDetails, getRegionWiseCreditDetails} from "lib/axiosUtils";

export const onSortColumn = (dataArray, column, orderFlag) => {
    let sortedData = [];
    if (orderFlag === "asc") {
        sortedData = dataArray.sort((a, b) => {
            if (a[column] < b[column]) return -1;
            if (a[column] > b[column]) return 1;
            if (a[column] === b[column]) return 1;
            return 1;
        });
    } else {
        sortedData = dataArray.sort((a, b) => {
            if (a[column] > b[column]) return -1;
            if (a[column] < b[column]) return 1;
            if (a[column] === b[column]) return 1;
            return 1;
        });
    }
    return sortedData;
}

export const defaultFormatDate = (item) => {
    let formatedDate = null;
    formatedDate = moment(item).format("DD-MM-YYYY");
    return formatedDate;
}

export const showLoading = (message = "Please wait...") => {
    Toast.loading(message, () => { });
}

export const hideLoading = () => {
    Toast.hide();
}

export const fetchMetadata = async () => {
    try {
        const getMetaData = await getMetaDataCall({}, {});
        localStorage.setItem("metadata", JSON.stringify(getMetaData.data.result));
        return getMetaData.data.result;
    }
    catch (error) {
        console.log("Error Occurred while fetching metadata", error);
    }
}

export const toCapitaliseWord = (string) => {
    return string.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
};

export const getAge = birthDate => Math.floor((new Date() - new Date(birthDate.split('/').reverse().join('-')).getTime()) / 3.15576e+10);

export const convertDateInCorrectFormat = (date) => {
    const selectedDate = new Date(date);
    const returnDate = new Date(Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
    ));
    return returnDate;
}

export const updateUserSessionData = async (userDetail) => {
    try {
        const data = await getUserDetails({}, {}, userDetail._id);
        localStorage.setItem("userData", null);
        localStorage.setItem("userData", JSON.stringify(data.data.result));
    }
    catch (error) {
        console.log("Error occurred while updaing user session data", error);
    }
}

export const getRequiredCredit = async (regionId,module) => {
    try{
        const creditData = await getRegionWiseCreditDetails({}, {}, regionId, module);
        const requiredCredit = creditData.data.result[0]?.credits;
        return requiredCredit;
    }catch(error){
        console.log("Error occurred while getting credits data", error);
    }
}

export const getUserLoginExternalToken = async (userName, password) => {
    userName = "admin@codingcanvas.com";
    password = "admin123";
    try {
        let requestData = {
            username: userName,
            password: password,
            grant_type: "password",
            scope: "",
            client_id: "",
            client_secret: "",
        }
        const result = await getLoginUserTokenForExternalAPICall({}, requestData);
        return result;
    }
    catch (error) {
        console.log("Error occurred while fetching the user login token", error);
    }
}